/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createIm } from '../../factoriesAny.js';
export var imDependencies = {
  typedDependencies: typedDependencies,
  createIm: createIm
};